export default function BulkActivationService($http, appSettings) {
	'ngInject';

  const bulkActivationEndpoint = appSettings.InReachApiBulkActivation;

  return {
    bulkActivate:function(file) {
      const formData = new FormData();
      formData.append('file', file);
      return $http.post(bulkActivationEndpoint, formData, { transformRequest: angular.identity,
        headers: {'Content-Type': undefined }});
    }
  };
}